var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBtnSendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.75V11.75C15 12.2141 14.8156 12.6592 14.4874 12.9874C14.1592 13.3156 13.7141 13.5 13.25 13.5H2.75C2.28587 13.5 1.84075 13.3156 1.51256 12.9874C1.18437 12.6592 1 12.2141 1 11.75V4.75",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.75C15 4.28587 14.8156 3.84075 14.4874 3.51256C14.1592 3.18437 13.7141 3 13.25 3H2.75C2.28587 3 1.84075 3.18437 1.51256 3.51256C1.18437 3.84075 1 4.28587 1 4.75L7.0725 8.54167C7.35063 8.7155 7.67201 8.80767 8 8.80767C8.32799 8.80767 8.64937 8.7155 8.9275 8.54167L15 4.75Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnSendMail);
export default __webpack_public_path__ + "static/media/icn_btn_send_mail.9900e35157881a4232235d7fa3d1c02f.svg";
export { ForwardRef as ReactComponent };